import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=00f14db2&scoped=true"
import script from "./Leads.vue?vue&type=script&lang=ts"
export * from "./Leads.vue?vue&type=script&lang=ts"
import style0 from "./Leads.vue?vue&type=style&index=0&id=00f14db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f14db2",
  null
  
)

export default component.exports